import { render, staticRenderFns } from "./SymptomTable.vue?vue&type=template&id=284711d1"
import script from "./SymptomTable.vue?vue&type=script&lang=js"
export * from "./SymptomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports